import { render, staticRenderFns } from "./adminlist.vue?vue&type=template&id=ce0dada2&scoped=true"
import script from "./adminlist.vue?vue&type=script&lang=js"
export * from "./adminlist.vue?vue&type=script&lang=js"
import style0 from "./adminlist.vue?vue&type=style&index=0&id=ce0dada2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce0dada2",
  null
  
)

export default component.exports